import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-right;
  flex-direction: column;
  align-items: center;
`;
